<template>
	<v-container>
		<v-card-actions>
			<v-spacer />
			<action-menu
				entity="job"
				:title="$tc('entities.job.title', 1)"
				:data="value"
			/>
		</v-card-actions>
		<v-tabs v-model="tab" vertical>
			<v-tab key="general">{{ $t("general") }}</v-tab>
			<v-tab key="CustomFields">{{ $t("customFields") }}</v-tab>
			<v-tab key="jobstages">{{ $tc("entities.jobStage.title", 2) }}</v-tab>
			<v-tabs-items v-model="tab">
				<v-tab-item key="general">
					<v-form ref="form" v-model="valid">
						<v-text-field
							:label="$t('entities.job.props.code')"
							v-model="value.code"
							:rules="$isRequiredRule"
						></v-text-field>
						<v-checkbox
							:label="$t('entities.job.props.group')"
							v-model="value.group"
						></v-checkbox>
						<v-select
							:items="jobStatusComp"
							:readonly="value.id != null"
							v-model="value.jobStatusId"
							item-text="status"
							item-value="id"
							:rules="$isRequiredRule"
							:label="$t('entities.job.props.status')"
						></v-select>

						<v-text-field
							:label="$t('entities.job.props.description')"
							v-model="value.description"
							:rules="$isRequiredRule"
						></v-text-field>
						<v-select
							:readonly="value.id"
							v-model="value.environmentId"
							:items="environments"
							item-text="description"
							item-value="id"
							:label="$t('entities.job.props.environmentId')"
							:rules="$isRequiredRule"
						></v-select>
						<auto-complete-entity
							ref="item"
							v-model="value.itemId"
							entityApi="item"
							:itemPreSelected="selectedItem"
							itemText="description"
							itemValue="id"
							:label="$t('entities.job.props.item')"
							prependIcon="mdi-find-replace"
						/>
						<v-select
							v-model="value.versionId"
							:items="versions"
							item-text="description"
							item-value="id"
							:label="$t('entities.job.props.version')"
						></v-select>
						<auto-complete-entity
							ref="account"
							v-model="value.accountId"
							entityApi="account"
							:itemPreSelected="selectedAccount"
							fieldApi="name"
							itemText="name"
							itemValue="id"
							:label="$t('entities.job.props.accountId')"
							prependIcon="mdi-find-replace"
						/>
						<date-dialog
							v-model="value.deadline"
							label="Deadline"
							format="DD/MM/YY"
						></date-dialog>
						<v-text-field
							:label="$t('entities.job.props.notes')"
							v-model="value.notes"
						></v-text-field>
					</v-form>
				</v-tab-item>
				<v-tab-item key="CustomFields" eager>
					<entity-field-custom-autoform
						v-model="value"
						entity="Job"
					></entity-field-custom-autoform>
				</v-tab-item>
				<v-tab-item key="jobstages">
					<v-alert v-if="!value.environmentId" type="error">{{
						$tc("entities.job.title", 1) +
							" " +
							$t("entities.job.props.environmentId") +
							": " +
							$t("errors.fieldRequired")
					}}</v-alert>

					<jobStageFormOffline
						ref="jobStagesFormRef"
						v-else
						v-model="value.jobStages"
						:environmentId="value.environmentId"
					/>
					<!-- <jobStageFormOnline
            :jobId="value.id"
            :environmentId="value.environmentId"
          /> -->
				</v-tab-item>
				<basic-history v-model="value"></basic-history>
			</v-tabs-items>
		</v-tabs>
	</v-container>
</template>

<script>
	// import itemPage from "@/views/ItemPage";
	// import accountPage from "@/views/AccountPage";
	import itemService from "@/services/itemService.js";
	import accountService from "@/services/accountService.js";
	import environmentService from "@/services/environmentService.js";
	import versionService from "@/services/versionService.js";
	import jobService from "@/services/jobService";
	//import jobStageFormOnline from "@/components/forms/jobStages/jobStageFormOnline";
	import jobStageFormOffline from "@/components/forms/jobStages/jobStageFormOffline";
	import jobStageService from "@/services/jobStageService";

	export default {
		components: {
			jobStageFormOffline,
		},
		props: {
			jobId: {},
			value: {
				default() {
					return {
						code: "",
						description: "",
						status: "",
						itemId: "",
						deadLine: "",
						accountId: "",
						environmentId: "",
						versionId: "",
					};
				},
			},
		},

		data() {
			return {
				valid: true,
				tab: null,
				versions: [],
				accounts: [],
				environments: [],
				selectedAccount: {},
				selectedItem: {},
				alert: {
					alerts: [],
					type: "error",
				},
			};
		},

		computed: {
			jobStatusComp() {
				let jobStatus = [];
				if (!this.value) return jobStatus;
				let env = this.environments.filter(
					(e) => e.id == this.value.environmentId
				)[0];
				if (!env) return jobStatus;
				return env.jobStatus;
			},
		},
		watch: {
			async value() {
				this.$refs.form.resetValidation();
				this.selectedItem = "";
				this.selectedAccount = "";
				await this.getItems();
			},
			async "value.itemId"() {
				this.value.versionId = null;
				await this.getVersions();
			},
		},
		methods: {
			async getJob() {
				if (!this.jobId) return;
				let res = await jobService.getById(this.jobId);
				if (res.success) this.value = res.data;
			},
			isValid() {
				if (this.$refs.jobStagesFormRef != null) {
					let jobStagesIsValid = this.$refs.jobStagesFormRef.saveChanges();
					if (!jobStagesIsValid) return false;
				}
				return this.$refs.form.validate();
			},
			async selectItem(row) {
				this.value.itemId = row.id;
				this.selectedItem = row;
				await this.getVersions();
			},
			selectAccount(row) {
				this.selectedAccount = row;
				this.value.accountId = row.id;
			},
			async getItemById() {
				if (!this.value.itemId) return;
				let res = await itemService.getById(this.value.itemId);

				if (res.success) this.selectedItem = res.data;
				else this.alert.alerts = res.data;
			},
			async getAccountById() {
				if (!this.value.accountId) return;
				let res = await accountService.getById(this.value.accountId);
				if (res.success) this.selectedAccount = res.data;
				else this.alert.alerts = res.data;
			},
			async getEnvironments() {
				let res = await environmentService.getAll();
				if (res.success) this.environments = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getVersions() {
				if (!this.value.itemId) return;
				let res = await versionService.getAll(this.value.itemId);
				if (res.success) this.versions = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getJobStages() {
				this.value.jobStages = [];
				let res = await jobStageService.getAll(this.value.id);
				if (res.success) this.value.jobStages = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getItems() {
				await this.getJobStages();
				await this.getEnvironments();
				await this.getAccountById();
				await this.getItemById();
				await this.getVersions();
				this.$forceUpdate();
			},
		},
		async mounted() {
			await this.getItems();
		},
	};
</script>
